import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../../util/Rest';
// import { GLOBAL_FIELD } from "../../../constants/MicroServiceConstants";

const initialData = {
  searchDataDetails: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'postSearch',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },

    postAdvanceSearch: (state, action) => {
      state.statusCode = action.payload.status;
      state.searchDataDetails = action.payload.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    resetStatus: (state, action) => {
      state.statusCode = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    resetMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
    },
  },
});

export default slice.reducer;

const {fetchStart, fetchError, postAdvanceSearch} = slice.actions;

export const postMaintainLetterSearch = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lettermaintenance/search/all`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postAdvanceSearch(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
